import { init, register } from 'svelte-i18n';

// Load locales dynamically via fetch to avoid Vite caching
// Add timestamp to force fresh load
// const loadLocale = async (locale) => {
//     try {
//         const response = await fetch(`/locale/${locale}/lastmile.json?t=${Date.now()}`);
//         return await response.json();
//     } catch (error) {
//         console.error(`Failed to load locale ${locale}:`, error);
//         return {};
//     }
// };
//
// register('pl', () => loadLocale('pl'));
// register('en', () => loadLocale('en'));
// register('de', () => loadLocale('de'));
// register('pl-x-36', () => loadLocale('pl36'));

register('pl', () => import('../../../locale/pl/lastmile.json'));
register('en', () => import('../../../locale/en/lastmile.json'));
register('pl-x-36', () => import('../../../locale/pl36/lastmile.json'));
register('pl-x-10', () => import('../../../locale/pl10/lastmile.json'));
register('cs', () => import('../../../locale/cs/lastmile.json'));


init({
    fallbackLocale: 'pl',
    initialLocale: 'pl', // localStorage.getItem('locale') || getLocaleFromNavigator(),
});

// https://github.com/kaisermann/svelte-i18n/blob/main/docs/Methods.md
// https://github.com/kaisermann/svelte-i18n/blob/main/docs/Locale.md